import React, { useState } from "react";
import axios from "axios";
import dayjs from 'dayjs';


const useCirculationRules = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, values }) => { },
}) => {
    const mainApi = '/koha/circulation_rules'
    const [type_data, setTypeData] = useState([])
    const [data, setData] = useState([])

    const getCirculationRulesTypeData = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get("/library" + mainApi + "/type", {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setTypeData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const getCirculationRulesData = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const getCirculationRulesP1Data = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get("/library" + mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                let filter_data = data?.data.filter(item => {
                    return item.p === "P1" && item?.filter === true
                });
                data["data"] = filter_data
                data["total"] = filter_data.length
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const getCirculationRulesP2Data = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                let filter_data = data?.data.filter(item => {
                    return item.p === "P2"
                });
                data["data"] = filter_data
                data["total"] = filter_data.length
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const getCirculationRulesP3Data = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                let filter_data = data?.data.filter(item => {
                    return item.p === "P3"
                });
                data["data"] = filter_data
                data["total"] = filter_data.length
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const getCirculationRulesP4Data = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                let filter_data = data?.data.filter(item => {
                    return item.p === "P4"
                });
                data["data"] = filter_data
                data["total"] = filter_data.length
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const getCirculationRulesP5Data = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                let filter_data = data?.data.filter(item => {
                    return item.p === "P5"
                });
                data["data"] = filter_data
                data["total"] = filter_data.length
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const getCirculationRulesP6Data = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                let filter_data = data?.data.filter(item => {
                    return item.p === "P6"
                });
                data["data"] = filter_data
                data["total"] = filter_data.length
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })
                return {
                    ...data
                }
            });
    }
    const postCirculationRulesP1Data = (data) => {
        onBefore({
            axiosMode: "post"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = {}
            current_rule_data["rules"] = []
            current_rule_data["rules"].push({ 
                rule_name: "article_requests", 
                rule_value: "no"
            })
            current_rule_data["rules"].push({ 
                rule_name: "unseen_renewals_allowed", 
                rule_value: ""
            })
            
            // 預設不填寫但必須有值
            current_rule_data["rules"].push({ 
                rule_name: "note", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "maxonsiteissueqty", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "decreaseloanholds", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "chargeperiod", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "overduefinescap", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "cap_fine_to_replacement_price", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "finedays", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "maxsuspensiondays", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "noautorenewalbefore", 
                rule_value: ""
            })
            current_rule_data["rules"].push({ 
                rule_name: "no_auto_renewal_after", 
                rule_value: ""
            })
            // current_rule_data["rules"].push({ 
            //     rule_name: "no_auto_renewal_after_hard_limit", 
            //     rule_value: ""
            // }) 

            for (const [key, value] of Object.entries(data[i])) {
                if(key !== "branchcode" && key !== "categorycode" && key !== "itemtype")
                    if(key === "hardduedate" || key === "no_auto_renewal_after_hard_limit") {
                        current_rule_data["rules"].push({ 
                            rule_name: key, 
                            rule_value: dayjs(value).format("YYYY-MM-DD")
                        }); 
                        current_rule_data["rules"].push({ 
                            rule_name: "no_auto_renewal_after_hard_limit", 
                            rule_value: dayjs(value).format("YYYY-MM-DD")
                        }); 
                    }
                    else if(key === "cap_fine_to_replacement_price") {
                        current_rule_data["rules"].push({ 
                            rule_name: key, 
                            rule_value: value ? "1" : "0"
                        }); 
                    }
                    else current_rule_data["rules"].push({ 
                        rule_name: key, 
                        rule_value: value
                    });
            }
            current_rule_data["categorycode"] = data[i]["categorycode"] === "*" ? null : data[i]["categorycode"]
            current_rule_data["itemtype"] = data[i]["itemtype"] === "*" ? null : data[i]["itemtype"]
            current_rule_data["branchcode"] = data[i]["branchcode"] === "*" ? null : data[i]["branchcode"]
            current_rule_data["p"] = "P1"
            body.push(current_rule_data)
        }
        axios.post(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P1"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "failure"
                    }
                )
            })
    }
    const postCirculationRulesP2Data = (data) => {
        onBefore({
            axiosMode: "post"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = {}
            current_rule_data["rules"] = []
            for (const [key, value] of Object.entries(data[i])) {
                if(key !== "branchcode" && key !== "categorycode" && key !== "itemtype")
                    current_rule_data["rules"].push({ 
                        rule_name: key, 
                        rule_value: value
                    });
            }
            current_rule_data["categorycode"] = null
            current_rule_data["itemtype"] = null
            current_rule_data["branchcode"] = data[i]["branchcode"]
            current_rule_data["p"] = "P2"
            body.push(current_rule_data)
        }
        axios.post(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P2"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "failure"
                    }
                )
            })
    }
    const postCirculationRulesP3Data = (data) => {
        onBefore({
            axiosMode: "post"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = {}
            current_rule_data["rules"] = []
            for (const [key, value] of Object.entries(data[i])) {
                if(key !== "branchcode" && key !== "categorycode" && key !== "itemtype")
                    current_rule_data["rules"].push({ 
                        rule_name: key, 
                        rule_value: value
                    });
            }
            current_rule_data["categorycode"] = data[i]["categorycode"]
            current_rule_data["itemtype"] = null
            current_rule_data["branchcode"] = data[i]["branchcode"]
            current_rule_data["p"] = "P3"
            body.push(current_rule_data)
        }
        axios.post(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P3"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "failure"
                    }
                )
            })
    }
    const postCirculationRulesP4Data = (data) => {
        onBefore({
            axiosMode: "post"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = {}
            current_rule_data["rules"] = []
            for (const [key, value] of Object.entries(data[i])) {
                if(key !== "branchcode" && key !== "categorycode" && key !== "itemtype")
                    current_rule_data["rules"].push({ 
                        rule_name: key, 
                        rule_value: value
                    });
            }
            current_rule_data["categorycode"] = data[i]["categorycode"] === "*" ? null : data[i]["categorycode"]
            current_rule_data["itemtype"] = data[i]["itemtype"] === "*" ? null : data[i]["itemtype"]
            current_rule_data["branchcode"] = data[i]["branchcode"]
            current_rule_data["p"] = "P4"
            body.push(current_rule_data)
        }
        axios.post(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P4"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "failure"
                    }
                )
            })
    }
    const postCirculationRulesP5Data = (data) => {
        onBefore({
            axiosMode: "post"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = {}
            current_rule_data["rules"] = []
            for (const [key, value] of Object.entries(data[i])) {
                if(key !== "branchcode" && key !== "categorycode" && key !== "itemtype")
                    current_rule_data["rules"].push({ 
                        rule_name: key, 
                        rule_value: value
                    });
            }
            current_rule_data["categorycode"] = null
            current_rule_data["itemtype"] = null
            current_rule_data["branchcode"] = data[i]["branchcode"]
            current_rule_data["p"] = "P5"
            body.push(current_rule_data)
        }
        axios.post(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P5"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "failure"
                    }
                )
            })
    }
    const postCirculationRulesP6Data = (data) => {
        onBefore({
            axiosMode: "post"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = {}
            current_rule_data["rules"] = []
            for (const [key, value] of Object.entries(data[i])) {
                if(key !== "branchcode" && key !== "categorycode" && key !== "itemtype")
                    current_rule_data["rules"].push({ 
                        rule_name: key, 
                        rule_value: value
                    });
            }
            current_rule_data["categorycode"] = null
            current_rule_data["itemtype"] = data[i]["itemtype"]
            current_rule_data["branchcode"] = data[i]["branchcode"]
            current_rule_data["p"] = "P6"
            body.push(current_rule_data)
        }
        axios.post(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P6"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "failure"
                    }
                )
            })
    }
    const patchCirculationRulesP1Data = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = data[i]["current_rule_data"]
            for (let j = 0; j < current_rule_data["rules"].length; j++) {
                if(current_rule_data["rules"][j]["rule_name"] === "hardduedate" || current_rule_data["rules"][j]["rule_name"] === "no_auto_renewal_after_hard_limit") {
                    current_rule_data["rules"][j]["rule_value"] = dayjs(data[i][current_rule_data["rules"][j]["rule_name"]]).format("YYYY-MM-DD")
                }
                else if(current_rule_data["rules"][j]["rule_name"] === "cap_fine_to_replacement_price") {
                    current_rule_data["rules"][j]["rule_value"] = data[i][current_rule_data["rules"][j]["rule_name"]] ? "1" : "0"
                }
                else current_rule_data["rules"][j]["rule_value"] = data[i][current_rule_data["rules"][j]["rule_name"]];
            }
            current_rule_data["categorycode"] = data[i]["categorycode"] === "*" ? null : data[i]["categorycode"]
            current_rule_data["itemtype"] = data[i]["itemtype"] === "*" ? null : data[i]["itemtype"]
            current_rule_data["branchcode"] = data[i]["branchcode"] === "*" ? null : data[i]["branchcode"]
            body.push(current_rule_data)
        }
        axios.patch(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P1"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const patchCirculationRulesP2Data = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = data[i]["current_rule_data"]
            for (let j = 0; j < current_rule_data["rules"].length; j++) {
                current_rule_data["rules"][j]["rule_value"] = data[i][current_rule_data["rules"][j]["rule_name"]];
            }
            current_rule_data["categorycode"] = null
            current_rule_data["itemtype"] = null
            current_rule_data["branchcode"] = data[i]["branchcode"]
            body.push(current_rule_data)
        }
        axios.patch(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P2"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const patchCirculationRulesP3Data = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = data[i]["current_rule_data"]
            for (let j = 0; j < current_rule_data["rules"].length; j++) {
                current_rule_data["rules"][j]["rule_value"] = data[i][current_rule_data["rules"][j]["rule_name"]];
            }
            current_rule_data["categorycode"] = data[i]["categorycode"]
            current_rule_data["itemtype"] = null
            current_rule_data["branchcode"] = data[i]["branchcode"]
            body.push(current_rule_data)
        }
        axios.patch(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P3"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const patchCirculationRulesP4Data = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = data[i]["current_rule_data"]
            for (let j = 0; j < current_rule_data["rules"].length; j++) {
                current_rule_data["rules"][j]["rule_value"] = data[i][current_rule_data["rules"][j]["rule_name"]];
            }
            current_rule_data["categorycode"] = data[i]["categorycode"] === "*" ? null : data[i]["categorycode"]
            current_rule_data["itemtype"] = data[i]["itemtype"] === "*" ? null : data[i]["itemtype"]
            current_rule_data["branchcode"] = data[i]["branchcode"]
            body.push(current_rule_data)
        }
        axios.patch(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P4"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const patchCirculationRulesP5Data = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = data[i]["current_rule_data"]
            for (let j = 0; j < current_rule_data["rules"].length; j++) {
                current_rule_data["rules"][j]["rule_value"] = data[i][current_rule_data["rules"][j]["rule_name"]];
            }
            current_rule_data["categorycode"] = null
            current_rule_data["itemtype"] = null
            current_rule_data["branchcode"] = data[i]["branchcode"]
            body.push(current_rule_data)
        }
        axios.patch(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P5"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const patchCirculationRulesP6Data = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        let body = []
        for (let i = 0; i < data.length; i++) {
            let current_rule_data = data[i]["current_rule_data"]
            for (let j = 0; j < current_rule_data["rules"].length; j++) {
                current_rule_data["rules"][j]["rule_value"] = data[i][current_rule_data["rules"][j]["rule_name"]];
            }
            current_rule_data["categorycode"] = null
            current_rule_data["itemtype"] = data[i]["itemtype"]
            current_rule_data["branchcode"] = data[i]["branchcode"]
            body.push(current_rule_data)
        }
        axios.patch(mainApi, body)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P6"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const deleteCirculationRulesP1Data = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi, { data })
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P1"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }
    const deleteCirculationRulesP2Data = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi, { data })
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P2"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }
    const deleteCirculationRulesP3Data = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi, { data })
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P3"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }
    const deleteCirculationRulesP4Data = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi, { data })
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P4"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }
    const deleteCirculationRulesP6Data = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi, { data })
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: {
                                ...responseData,
                                current_rule: "P6"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }
    const postCirculationRulesClone = (data) => {
        onBefore({
            axiosMode: "post"
        })
        // axios.post(mainApi,
        //     data
        // )
        //     .then((response) => {
        //         let responseData = response.data
        //         let status = responseData?.status
        //         if (status === "success") {
        //             onFinish(
        //                 {
        //                     axiosMode: "post",
        //                     status: "success"
        //                 }
        //             )
        //         }
        //         else {
        //             onFinish(
        //                 {
        //                     axiosMode: "post",
        //                     status: "error"
        //                 }
        //             )
                   
        //         }
        //     })
        //     .catch(() => {
        //         onFinish(
        //             {
        //                 axiosMode: "post",
        //                 status: "error"
        //             }
        //         )
        //     })

    }
    const postCirculationRulesData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                   
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchCirculationRulesData = (data) => {
        
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                   
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteCirculationRulesData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                   
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        CirculationRulesTypeData: type_data, 
        CirculationRulesData: data,
        postCirculationRulesClone, 
        getCirculationRulesTypeData, 
        getCirculationRulesP1Data,
        postCirculationRulesP1Data,
        patchCirculationRulesP1Data,
		deleteCirculationRulesP1Data,
        getCirculationRulesP2Data,
        postCirculationRulesP2Data, 
        patchCirculationRulesP2Data,
        deleteCirculationRulesP2Data, 
        getCirculationRulesP3Data,
        postCirculationRulesP3Data, 
        patchCirculationRulesP3Data,
        deleteCirculationRulesP3Data, 
        getCirculationRulesP4Data,
        postCirculationRulesP4Data, 
        patchCirculationRulesP4Data,
        getCirculationRulesP5Data,
        postCirculationRulesP5Data, 
        patchCirculationRulesP5Data,
        getCirculationRulesP6Data,
        postCirculationRulesP6Data,
        patchCirculationRulesP6Data,
        getCirculationRulesData,
        postCirculationRulesData,
        patchCirculationRulesData,
        deleteCirculationRulesData,
        deleteCirculationRulesP4Data, 
        deleteCirculationRulesP6Data, 
    }
}
export { useCirculationRules }
